import { ButtonProps } from "@mui/material";
import styles from "./styles.module.css";
import { AppButton } from "../../../../shared/components/AppButton";

export const SaveSchemaBtn = ({ ...props }: ButtonProps) => {
  return (
    <AppButton
      buttonType={"outlined"}
      className={styles["save-btn"]}
      {...props}
    >
      {"Сохранить на устройство"}
    </AppButton>
  );
};
